import { SDate } from '@summit/core';
import { SummitIdObject } from '@summit/models';
import { Dayjs } from 'dayjs';
import { EventLevel } from './event-level.enum';
import { EventStatus } from './event-status.enum';
// TODO move to job dispatcher folder

export class EventLog extends SummitIdObject {
  declare id: string;
  eventTime: Dayjs;
  eventLevel: EventLevel;
  summary: string;
  status: EventStatus;
  urlLabel: string;
  urlLink: string;
  updateLabel: string;

  constructor(data: Partial<EventLog>) {
    super(data);
    if (data) {
      if (data.eventTime) this.eventTime = SDate.newUtc(data.eventTime);
    }
    this.eventTime ??= SDate.newUtc();
    this.status ??= EventStatus.Complete;
  }

  public get isInProgress(): boolean {
    return this.status === EventStatus.InProgress;
  }

  public get IsFailed(): boolean {
    return this.status === EventStatus.Failed;
  }

  public static NewEventFrom(
    eventLevel: EventLevel,
    summary: string,
    status?: EventStatus,
    urlLabel?: string,
    urlLink?: string
  ): EventLog {
    return new EventLog({
      eventLevel,
      summary,
      status,
      urlLabel,
      urlLink
    });
  }
}
